'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Element = require("rescript-webapi/lib/js/src/Webapi/Dom/Webapi__Dom__Element.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");

var statValue = Curry._1(Css.style, {
      hd: Css.color(Css.hex("797c82")),
      tl: {
        hd: Css.fontSize(Css.px(18)),
        tl: {
          hd: Css.focus({
                hd: Css.color(Css.hex("c2c6cf")),
                tl: /* [] */0
              }),
          tl: {
            hd: Css.width(Css.px(50)),
            tl: /* [] */0
          }
        }
      }
    });

var error = Curry._1(Css.style, {
      hd: Css.color(Css.red),
      tl: {
        hd: Css.height(Css.px(21)),
        tl: /* [] */0
      }
    });

var tooltip = Curry._1(Css.style, {
      hd: Css.textDecoration(Css.underline),
      tl: {
        hd: Css.textDecorationStyle(Css.dotted),
        tl: {
          hd: Css.marginLeft(Css.px(5)),
          tl: {
            hd: Css.cursor("help"),
            tl: /* [] */0
          }
        }
      }
    });

function onKeyPress($$event) {
  var key = $$event.key;
  if (key !== "Enter") {
    return ;
  }
  var target = $$event.target;
  return Belt_Option.mapWithDefault(Webapi__Dom__Element.asHtmlElement(target), undefined, (function (prim) {
                prim.blur();
                
              }));
}

function onChangeValue(param, extractStateObject, applyToStateObject, currentValue, parseString, setValueState, $$event) {
  var value = $$event.target.value;
  $$event.target.value = "";
  var value$1 = Curry._1(parseString, value);
  var match = Curry._1(extractStateObject, param[0]);
  if (match === undefined) {
    return ;
  }
  if (value$1 === undefined) {
    return ;
  }
  var value$2 = Caml_option.valFromOption(value$1);
  var object = Caml_option.valFromOption(match);
  if (Caml_obj.caml_notequal(value$2, currentValue)) {
    Curry._1(setValueState, (function (_previousState) {
            return /* WaitingChangeConfirm */1;
          }));
  }
  return Curry._1(param[1], (function (_previousState) {
                return Curry._2(applyToStateObject, object, value$2);
              }));
}

function onChangeIntValue(stateHook, extractStateObject, applyToStateObject, currentValue, setValueState, $$event) {
  return onChangeValue(stateHook, extractStateObject, applyToStateObject, currentValue, Belt_Int.fromString, setValueState, $$event);
}

function intFromTimeString(str) {
  return Belt_Int.fromString(str.replace(":", ""));
}

function onChangedTimeValue(stateHook, extractStateObject, applyToStateObject, currentValue, setValueState, $$event) {
  return onChangeValue(stateHook, extractStateObject, applyToStateObject, currentValue, intFromTimeString, setValueState, $$event);
}

function onChangeIntPercentValue(stateHook, extractStateObject, applyToStateObject, currentValue, setValueState, $$event) {
  return onChangeValue(stateHook, extractStateObject, applyToStateObject, currentValue, (function (value) {
                return Belt_Int.fromString(value.replace("%", ""));
              }), setValueState, $$event);
}

function onChangeUnsignedIntPercentValue(stateHook, extractStateObject, applyToStateObject, currentValue, setValueState, $$event) {
  return onChangeValue(stateHook, extractStateObject, applyToStateObject, currentValue, (function (value) {
                var str = value.replace("%", "");
                return Belt_Option.map(Belt_Int.fromString(str), (function (num) {
                              if (num >= 0) {
                                return num;
                              } else {
                                return -num | 0;
                              }
                            }));
              }), setValueState, $$event);
}

function boolFromString(str) {
  var match = str.toLowerCase();
  switch (match) {
    case "1" :
    case "on" :
    case "y" :
    case "ye" :
    case "yes" :
        return true;
    default:
      return false;
  }
}

function onChangeBooleanValue(stateHook, extractStateObject, applyToStateObject, currentValue, setValueState, $$event) {
  return onChangeValue(stateHook, extractStateObject, applyToStateObject, currentValue, boolFromString, setValueState, $$event);
}

function syncValue(v, param, updateValue, onUpdateSuccess) {
  var setValueState = param[1];
  var valueState = param[0];
  React.useEffect((function () {
          if (valueState !== 1) {
            return ;
          } else {
            return Curry._2(updateValue, v, (function (result) {
                          if (result.TAG === /* Ok */0 && result._0.status === 200) {
                            Curry._1(setValueState, (function (_previousState) {
                                    return /* Synced */0;
                                  }));
                            if (onUpdateSuccess !== undefined) {
                              return Curry._1(onUpdateSuccess, undefined);
                            } else {
                              return ;
                            }
                          }
                          return Curry._1(setValueState, (function (_previousState) {
                                        return /* SyncFailed */2;
                                      }));
                        }));
          }
        }), [valueState]);
  
}

function EditableValue(Props) {
  var classNameOpt = Props.className;
  var tooltip$1 = Props.tooltip;
  var model = Props.model;
  var session = Props.session;
  var editMode = Props.editMode;
  var label = Props.label;
  var value = Props.value;
  var onChange = Props.onChange;
  var updateValue = Props.updateValue;
  var onUpdateSuccess = Props.onUpdateSuccess;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var match = React.useState(function () {
        return /* Synced */0;
      });
  var setState = match[1];
  var state = match[0];
  if (typeof session === "object" && session.NAME !== "VerifiedNoManage") {
    syncValue(model, [
          state,
          setState
        ], Curry._1(updateValue, session), onUpdateSuccess);
  } else {
    Debugging$PvpcontrollerWeb.info("Not syncing");
  }
  var tooltipElement = tooltip$1 !== undefined ? React.createElement("span", {
          className: tooltip,
          title: tooltip$1
        }, "?") : React.createElement(React.Fragment, undefined);
  var tmp;
  switch (state) {
    case /* Synced */0 :
        tmp = editMode !== 1 ? React.createElement("div", {
                className: statValue
              }, value) : React.createElement("input", {
                className: statValue,
                placeholder: value,
                onKeyPress: onKeyPress,
                onBlur: Curry._1(onChange, setState)
              });
        break;
    case /* WaitingChangeConfirm */1 :
        tmp = React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps({
                  height: "13px",
                  margin: "0",
                  width: "13px"
                }, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
        break;
    case /* SyncFailed */2 :
        tmp = React.createElement("i", {
              className: "fas fa-exclamation-circle " + error,
              title: "Update failed. Click to try again.",
              onClick: (function (_event) {
                  return Curry._1(setState, (function (_previousState) {
                                return /* WaitingChangeConfirm */1;
                              }));
                })
            });
        break;
    
  }
  return React.createElement("div", {
              className: className
            }, React.createElement("div", {
                  className: Theme$PvpcontrollerWeb.label
                }, label, tooltipElement), tmp);
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8, prim9, prim10, prim11) {
  var tmp = {
    model: prim2,
    session: prim3,
    editMode: prim4,
    label: prim5,
    value: prim6,
    onChange: prim7,
    updateValue: prim8
  };
  if (prim0 !== undefined) {
    tmp.className = Caml_option.valFromOption(prim0);
  }
  if (prim1 !== undefined) {
    tmp.tooltip = Caml_option.valFromOption(prim1);
  }
  if (prim9 !== undefined) {
    tmp.onUpdateSuccess = Caml_option.valFromOption(prim9);
  }
  if (prim10 !== undefined) {
    tmp.key = prim10;
  }
  return tmp;
}

var make = EditableValue;

exports.onChangeIntValue = onChangeIntValue;
exports.onChangedTimeValue = onChangedTimeValue;
exports.onChangeIntPercentValue = onChangeIntPercentValue;
exports.onChangeUnsignedIntPercentValue = onChangeUnsignedIntPercentValue;
exports.onChangeBooleanValue = onChangeBooleanValue;
exports.makeProps = makeProps;
exports.make = make;
/* statValue Not a pure module */
